module.exports = __webpack_public_path__ + "img/mylists-navbar-icon.f99cb038.svg";